
import './index.less'
import React from 'react'
const te = ['', '', '', '', '', '', '', '', '', 'officialAccount']
console.log(React)
export default function Suspension(props) {
  const src = props.ifon.imageIfon.path

  const typeItem = props.ifon.myType[te[props.ifon.type]]

  return (<div className={`suspension ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}>
    <div className='suspension_content'>
      <div className='content_left'>
        {props.ifon.style_type === 0 && <div className='left_img'>
          {src && <img className='img' src={props.ifon.imageIfon.path} />}
        </div>}

        <div className='left_ifon'>
          <h3 className='ifon_title' style={{
            color: props.ifon.title_color
          }}>{props.ifon.title ? props.ifon.title : '标题'}</h3>
          {props.ifon.style_type !== 2 && <span className='ifon_tips' style={{
            color: props.ifon.desc_color
          }}>{props.ifon.desc ? props.ifon.desc : '描述'}</span>}

        </div>
      </div>
      <div className='content_right'>
        <button className='right_button' style={{
          fontWeight: typeItem.text_alignment ? 'bold' : 'normal',
          backgroundColor: typeItem.bg_color,
          color: typeItem.font_color
        }}>{typeItem.title}</button>
      </div>
    </div>
  </div >)
}
